/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ReservationsInputs */

const en_reservations = /** @type {(inputs: ReservationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservations`)
};

const es_reservations = /** @type {(inputs: ReservationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservas`)
};

/**
* | output |
* | --- |
* | "Reservations" |
*
* @param {ReservationsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reservations = /** @type {((inputs?: ReservationsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ReservationsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reservations(inputs)
	return es_reservations(inputs)
});